export default __webpack_public_path__ + "media/zurb/img/legacy/spur/rotate-e2742d85aa7601ca357fc32239234ba4.jpg";